import React from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import { navigationOffsetState } from '@mo-recoil/common/navigation/atom';
import { showFooterState } from '@mo-recoil/common/footer/atom';
import SkypassContactInfo from '@ecp/mo/sites/skypass/components/footer/SkypassContactInfo';
import SkypassFooterNotice from '@ecp/mo/sites/skypass/components/footer/SkypassFooterNotice';
import SkypassFooterEventNotice from '@ecp/mo/sites/skypass/components/footer/SkypassFooterEventNotice';
import SkypassTermsAndConditions from '@ecp/mo/sites/skypass/components/footer/SkypassTermsAndConditions';
import SkypassFooterBusinessInfo from '@ecp/mo/sites/skypass/components/footer/SkypassFooterBusinessInfo';
import { Container } from '@ecp/mo/sites/skypass/styles/footer/SkypassFooterStyles';

export default function SkypassFooter() {
  const showFooter = useRecoilValue(showFooterState);
  const navigationOffset = useRecoilValue(navigationOffsetState);
  const { pathname } = useLocation();
  // [WIP-33461] 대한항공 /event 페이지 여부 flag값
  const isEventPage = pathname.startsWith('/event');

  return (
    <>
      {showFooter && (
        <Container>
          {/* 알아두세요 */}
          {/* 대한항공 footer 영역 /event 페이지면 SkypassFooterEventNotice 이외 페이지면 SkypassFooterNotice */}
          {isEventPage ? <SkypassFooterEventNotice /> : <SkypassFooterNotice />}

          {/* 이용약관, 개인정보처리방침, 로그인 버튼 */}
          <SkypassTermsAndConditions />
          <HorizontalDivider />

          {/* 사업자정보 */}
          <SkypassFooterBusinessInfo />

          {/* 고객지원 */}
          <SkypassContactInfo />
          <Spacing top={navigationOffset} />
          {navigationOffset === 0 && <Spacing bottom={'65px'} />}
        </Container>
      )}
    </>
  );
}
